import _ from 'underscore';
import { CampaignAdgroupSelectorView } from '@bingads-webui-campaign-react/campaign-adgroup-selector';
import { getCampaignData, getAdgroupData } from '@bingads-webui-campaign-legacy/adgroup-create-advanced/view/adgroup-selector-repository';
import withUiBlock from '@bingads-webui-component-legacy/uiblocker/index';

const i18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/campaign-adgroup-selector');

const CAMPAIGN_PAGESIZE = 10;
const ADGROUP_PAGESIZE = 6;

export default class AdgroupSelectorProxy {

  constructor({
    onAdGroupSelect = _.noop,
  }) {
    this.onAdGroupSelect = onAdGroupSelect;
  }

  fecthCampaignData({
    query = '', pageNumber = 0, pageSize = CAMPAIGN_PAGESIZE,
  }, adgroupSelectorView) {

    const uiBlockContainer = adgroupSelectorView && adgroupSelectorView.$('.dropdown-menu');

    return getCampaignData(query, pageNumber, pageSize).finally(withUiBlock(uiBlockContainer));
  }

  fecthAdgroupData({
    query = '', pageNumber = 0, pageSize = CAMPAIGN_PAGESIZE, scopeParentItem = null,
  }, adgroupSelectorView) {
    const uiBlockContainer = adgroupSelectorView && adgroupSelectorView.$('.dropdown-menu');

    return getAdgroupData(query, pageNumber, pageSize, scopeParentItem).finally(withUiBlock(uiBlockContainer));
  }

  getAdgroupSelectorView() {

    const adgroupSelectorView = new CampaignAdgroupSelectorView({
      campaign: {
        pageSize: CAMPAIGN_PAGESIZE,
        onFetch: (args) => {
          return this.fecthCampaignData(args, adgroupSelectorView);
        },
        ariaLabel: i18n.getString('Campaign_List'),
      },
      adgroup: {
        pageSize: ADGROUP_PAGESIZE,
        onFetch: (args) => {
          return this.fecthAdgroupData(args, adgroupSelectorView);
        },
        ariaLabel: i18n.getString('Adgroup_List'),
      },
      i18n,
    });

    adgroupSelectorView.on('selected-adgroup', (selectedItem) => {
      this.onAdGroupSelect(selectedItem);
    });

    return adgroupSelectorView;
  }
}

